export default "__VITE_ASSET__BTBLQ_3g__"